module.exports = __webpack_public_path__ + "static/media/logo132.5729a936.png";